var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-form",
    { ref: "form" },
    [
      _c("v-text-field", {
        attrs: {
          label: "Field Name",
          rules: [_vm.rules.required],
          required: "",
          disabled: false && _vm.isUpdate,
        },
        model: {
          value: _vm.formObject.Field,
          callback: function ($$v) {
            _vm.$set(_vm.formObject, "Field", $$v)
          },
          expression: "formObject.Field",
        },
      }),
      _vm._v(" "),
      _c("v-select", {
        attrs: {
          label: "Field Value Type",
          rules: [_vm.rules.required],
          items: _vm.fieldTypeItems,
          "item-text": "text",
          "item-value": "value",
          required: "",
          disabled: false && _vm.isUpdate,
        },
        on: {
          input: function ($event) {
            return _vm.clearValue()
          },
        },
        model: {
          value: _vm.fieldType,
          callback: function ($$v) {
            _vm.fieldType = $$v
          },
          expression: "fieldType",
        },
      }),
      _vm._v(" "),
      _vm.fieldType == _vm.METADATA_FIELD_TYPES.datetime.value
        ? _c(
            "v-menu",
            {
              attrs: {
                rules: [_vm.rules.required],
                "close-on-content-click": false,
                transition: "scale-transition",
                "offset-y": "",
                "full-width": "",
                "nudge-right": 40,
                "max-width": "290px",
                "min-width": "290px",
              },
              model: {
                value: _vm.dateMenu,
                callback: function ($$v) {
                  _vm.dateMenu = $$v
                },
                expression: "dateMenu",
              },
            },
            [
              _c("v-text-field", {
                attrs: {
                  slot: "activator",
                  label: "Field Value",
                  readonly: "",
                  "prepend-inner-icon": "event",
                },
                slot: "activator",
                model: {
                  value: _vm.prettyDateValue,
                  callback: function ($$v) {
                    _vm.prettyDateValue = $$v
                  },
                  expression: "prettyDateValue",
                },
              }),
              _vm._v(" "),
              _c("v-date-picker", {
                attrs: { "no-title": "", scrollable: "", actions: "" },
                on: {
                  input: function ($event) {
                    _vm.dateMenu = false
                  },
                },
                model: {
                  value: _vm.formObject.FieldValue,
                  callback: function ($$v) {
                    _vm.$set(_vm.formObject, "FieldValue", $$v)
                  },
                  expression: "formObject.FieldValue",
                },
              }),
            ],
            1
          )
        : _vm.fieldType == _vm.METADATA_FIELD_TYPES.string.value
        ? _c("v-text-field", {
            attrs: {
              rules: [_vm.rules.required],
              label: "Field Value",
              required: "",
            },
            model: {
              value: _vm.formObject.FieldValue,
              callback: function ($$v) {
                _vm.$set(_vm.formObject, "FieldValue", $$v)
              },
              expression: "formObject.FieldValue",
            },
          })
        : _vm.fieldType == _vm.METADATA_FIELD_TYPES.number.value
        ? _c("v-text-field", {
            attrs: {
              rules: [_vm.rules.required],
              label: "Field Value",
              type: "number",
              required: "",
            },
            model: {
              value: _vm.formObject.FieldValue,
              callback: function ($$v) {
                _vm.$set(_vm.formObject, "FieldValue", _vm._n($$v))
              },
              expression: "formObject.FieldValue",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("v-select", {
        attrs: {
          label: "Ordinal In The List",
          rules: [_vm.rules.required],
          items: _vm.ordinalInTheList,
          required: "",
        },
        model: {
          value: _vm.formObject.Ordinal,
          callback: function ($$v) {
            _vm.$set(_vm.formObject, "Ordinal", $$v)
          },
          expression: "formObject.Ordinal",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }